import { render, staticRenderFns } from "./complaint-detail.vue?vue&type=template&id=33eb7aa3"
import script from "./complaint-detail.vue?vue&type=script&lang=js"
export * from "./complaint-detail.vue?vue&type=script&lang=js"
import style0 from "./complaint-detail.vue?vue&type=style&index=0&id=33eb7aa3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports